import router from './module/router';

router.resolve();
